import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';
import React, { memo } from 'react';
import { Pressable } from 'react-native';

type AddPlayerEmptyCardProps = {
  onPress?: () => void;
};

function AddPlayerEmptyCard({ onPress }: AddPlayerEmptyCardProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="Add a player"
      onPress={onPress}
      style={({ pressed }) => [pressed && { opacity: 0.72 }]}>
      <Stack
        style={styles.card}
        align="center"
        gap={scale(8)}
        paddingY={scale(20)}
        paddingX={scale(16)}>
        {/* Plus circle */}
        <Stack
          width={scale(44)}
          height={scale(44)}
          borderRadius={scale(22)}
          align="center"
          justify="center"
          style={styles.plusCircle}>
          <SvgIcon name="IcPlusBold" size={scale(20)} color={colors.Blue} />
        </Stack>

        {/* Label */}
        <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.label}>
          {STRINGS.home.guardian.addPlayerEmptyCard.title}
        </Text>

        {/* Subtitle */}
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 11 Regular"
          style={styles.subtitle}
          numberOfLines={2}>
          {STRINGS.home.guardian.addPlayerEmptyCard.subtitle}
        </Text>
      </Stack>
    </Pressable>
  );
}

const useStyles = createStyles(({ scale }) => ({
  card: {
    backgroundColor: colors['0'],
    borderRadius: scale(16),
    borderCurve: 'continuous',
    borderWidth: 1.5,
    borderStyle: 'dashed',
    borderColor: colors.Blue,
    paddingHorizontal: scale(16),
  },
  plusCircle: {
    backgroundColor: guardianColors['1'],
  },
  label: {
    color: colors.Blue,
  },
  subtitle: {
    color: guardianColors['6'],
    textAlign: 'center',
    paddingHorizontal: scale(32),
  },
}));

export default memo(AddPlayerEmptyCard);
export type { AddPlayerEmptyCardProps };
